import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helper?: string;
  error?: string;
  required?: boolean;
}

const Input: React.FC<InputProps> = ({
  label,
  helper,
  error,
  required,
  className = '',
  id,
  ...props
}) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
  
  const baseStyles = 'w-full px-4 py-2 rounded-lg border transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
  const stateStyles = error
    ? 'border-orange-900 focus:ring-orange-600'
    : 'border-grey-300 focus:border-green-600 focus:ring-green-600';
  
  return (
    <div className="space-y-1">
      {label && (
        <label
          htmlFor={inputId}
          className="block font-sans text-sm font-medium text-black"
        >
          {label}
          {required && <span className="text-orange-900 ml-1">*</span>}
        </label>
      )}
      
      <input
        id={inputId}
        className={`${baseStyles} ${stateStyles} ${className}`}
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : helper ? `${inputId}-helper` : undefined}
        {...props}
      />
      
      {helper && !error && (
        <p id={`${inputId}-helper`} className="font-sans text-sm text-grey-600">
          {helper}
        </p>
      )}
      
      {error && (
        <p id={`${inputId}-error`} className="font-sans text-sm text-orange-900">
          {error}
        </p>
      )}
    </div>
  );
};

export default Input; 